import {AbstractMqttService, FakeMqttService} from '~core/api/mqtt/abstract-mqtt.service';
import {environment} from '~env/environment';
import {EventMqttService} from '~core/api/mqtt/event-mqtt.service';
import {MqttService} from 'ngx-mqtt';
import {Store} from '@ngrx/store';
import {mqttOptions} from '~env/mqtt';

export const MqttFactory = (store: Store): AbstractMqttService => {
  if (environment.experimentalFeatures?.showChat) {
    const service = new MqttService(mqttOptions(environment.mqtt));
    return new EventMqttService(store, service);
  }
  return new FakeMqttService();
};
